import React from 'react';

import PropTypes from 'prop-types';

import DashboardBaseView from './DashboardBaseView';

const DashBoardSplashView = (
  props
) => {

  return (
    <div>
      <DashboardBaseView
        {...props}
      >
      </DashboardBaseView>
    </div>
  );
}

DashboardBaseView.propTypes = {

}

export default DashBoardSplashView;
